import { render, staticRenderFns } from "./AddRegistrationNumberDialog.vue?vue&type=template&id=66cbeb70&scoped=true"
import script from "./AddRegistrationNumberDialog.vue?vue&type=script&lang=js"
export * from "./AddRegistrationNumberDialog.vue?vue&type=script&lang=js"
import style0 from "./AddRegistrationNumberDialog.vue?vue&type=style&index=0&id=66cbeb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cbeb70",
  null
  
)

export default component.exports